var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreemeltPixelmelt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 466.343,
    height: 65.046,
    viewBox: "0 0 466.343 65.046",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1715",
    "data-name": "Group 1715",
    transform: "translate(-712.828 -843.727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1714",
    "data-name": "Group 1714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1713",
    "data-name": "Group 1713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1708",
    "data-name": "Group 1708",
    transform: "translate(10.297 51.232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M13.85-27.6a6.359,6.359,0,0,0-6.05,4H7.7v-3.3H2.6V8.8H8V-3.15h.1A6.2,6.2,0,0,0,14.2.7c5.3,0,8.3-4.75,8.3-13.8C22.5-22.75,19.75-27.6,13.85-27.6ZM7.7-13.7c0-6.45,1.1-9.6,4.55-9.6,3.85,0,4.55,4,4.55,9.95,0,6.9-1.15,9.75-4.5,9.75C8.65-3.6,7.7-7,7.7-13.7ZM26.9-26.9V0h5.4V-26.9Zm8.8,0,6.95,12.95L35.3,0h5.75l4.7-9.95,1.807,3.92L51.869-8.39,49-13.95,56-26.9H50.2L45.8-18l-4.2-8.9Zm32.55-.7c-6.65,0-9.95,4.6-9.95,14.55C58.3-.65,63.65.7,68.15.7,73.8.7,77.6-2.75,77.6-9H72.5c0,1.4-.35,6-4.3,6-4.35,0-4.5-5.35-4.5-8.55v-1.2H77.75v-3.1C77.75-23.85,75.1-27.6,68.25-27.6ZM63.7-16.45V-17c0-4.25,1.55-6.9,4.45-6.9,2.75,0,4.2,2,4.2,6.1v1.35ZM82.45-35.2V0h5.4V-35.2Zm22.8,7.6a7.51,7.51,0,0,0-6.45,3.85h-.15V-26.9h-5.1V0h5.4V-18.1c0-3.1,1.75-5.2,4.25-5.2,2.35,0,3.3,1.45,3.3,4.8V0h5.4V-18.1c0-3.25,1.9-5.2,4.3-5.2,2.45,0,3.25,1.7,3.25,4.85V0h5.4V-20.45c0-4.6-2.15-7.15-6.55-7.15-2.85,0-5.05,1.15-6.8,4.1C110.45-26.55,108.15-27.6,105.25-27.6Zm34.25,0c-6.65,0-9.95,4.6-9.95,14.55C129.55-.65,134.9.7,139.4.7c5.65,0,9.45-3.45,9.45-9.7h-5.1c0,1.4-.35,6-4.3,6-4.35,0-4.5-5.35-4.5-8.55v-1.2H149v-3.1C149-23.85,146.35-27.6,139.5-27.6Zm-4.55,11.15V-17c0-4.25,1.55-6.9,4.45-6.9,2.75,0,4.2,2,4.2,6.1v1.35ZM153.7-35.2V0h5.4V-35.2Zm10.15,0V-6.05c0,5.65,2.25,6.35,5.5,6.35a18.021,18.021,0,0,0,4.3-.45v-4A10.284,10.284,0,0,1,171.7-4c-1.9,0-2.45-.8-2.45-2.8V-22.9h4.4v-4h-4.4v-8.3Z",
    transform: "translate(995.225 841.218)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7506",
    "data-name": "Ellipse 7506",
    cx: 2.75,
    cy: 2.75,
    r: 2.75,
    transform: "translate(1044.5 835.75)",
    fill: "#15ae7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1711",
    "data-name": "Group 1711",
    transform: "translate(-469.703 -84.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1678",
    "data-name": "Group 1678",
    transform: "translate(-47.469 831.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freemelt-logo_1_",
    "data-name": "freemelt-logo (1)",
    transform: "translate(1264.006 100.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M64,17.4v-3.1c0-4.933,2.8-6.561,7.322-6.561,1.272,0,2.492.051,3.764.153v4.982a12.85,12.85,0,0,0-1.373-.049c-1.984,0-2.7.609-2.7,2.185V17.4h4.069v4.779H71.018V44.752H64V22.175",
    transform: "translate(0 0)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M72.818,14.279H79.53V17.94h.1c1.424-2.644,3.408-4.373,6.306-4.373a10.424,10.424,0,0,1,1.27.1v6.711c-.71-.051-1.474-.1-2.186-.1-2.441,0-5.186,1.27-5.186,4.931V41.635H72.818Z",
    transform: "translate(4.71 3.116)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M90.21,29.026v2.186c0,3.2.865,6.355,3.458,6.355,2.338,0,3.3-1.778,3.713-5.135h6.3c-.255,6.358-3.3,9.915-9.916,9.915-10.168,0-10.577-7.829-10.577-14.645,0-7.322,1.425-14.134,10.884-14.134,8.187,0,10.014,5.491,10.014,13.881v1.577Zm7.17-4.17c-.153-4.17-.663-6.508-3.558-6.508-2.8,0-3.612,2.9-3.612,5.441v1.068h7.17Z",
    transform: "translate(10.253 3.117)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M105.556,29.026v2.186c0,3.2.865,6.355,3.458,6.355,2.338,0,3.3-1.778,3.713-5.135h6.3c-.255,6.358-3.3,9.915-9.916,9.915-10.168,0-10.577-7.829-10.577-14.645,0-7.322,1.425-14.134,10.884-14.134,8.187,0,10.014,5.491,10.014,13.881v1.577Zm7.171-4.17c-.153-4.17-.663-6.508-3.558-6.508-2.8,0-3.612,2.9-3.612,5.441v1.068h7.17Z",
    transform: "translate(18.452 3.117)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M114.55,14.279h6.712v2.8h.1a7.805,7.805,0,0,1,6.917-3.509c3.2,0,5.543,1.576,6.306,4.373h.1c1.068-2.9,3.612-4.373,6.918-4.373,4.626,0,6.811,2.9,6.811,8.187V41.635H141.4V22.516c0-2.288-.763-3.558-2.746-3.558-2.237,0-3.661,1.525-3.661,4.678v18h-7.018V22.516c0-2.288-.763-3.558-2.745-3.558-2.239,0-3.662,1.525-3.662,4.678v18h-7.016V14.279Z",
    transform: "translate(27.006 3.116)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M146.028,29.026v2.186c0,3.2.865,6.355,3.458,6.355,2.338,0,3.3-1.778,3.713-5.135h6.3c-.255,6.358-3.3,9.915-9.916,9.915-10.168,0-10.577-7.829-10.577-14.645,0-7.322,1.425-14.134,10.884-14.134,8.187,0,10.014,5.491,10.014,13.881v1.577Zm7.171-4.17c-.153-4.17-.663-6.508-3.558-6.508-2.8,0-3.612,2.9-3.612,5.441v1.068h7.17Z",
    transform: "translate(40.075 3.117)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_910",
    "data-name": "Rectangle 910",
    width: 7.016,
    height: 35.187,
    transform: "translate(203.905 9.566)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M162.969,16.758V8.927h7.018v7.831h4.069v4.779h-4.069v14.8c0,2.134.457,3,2.492,3a14.207,14.207,0,0,0,1.577-.1v4.884a43.936,43.936,0,0,1-4.578.3c-5.491,0-6.508-1.677-6.508-7.22V21.537",
    transform: "translate(52.876 0.637)",
    fill: "#fafafa"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M0,0V59",
    transform: "translate(990.797 844.75)",
    fill: "none",
    stroke: "#15ae7a",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "freemelt-logo_3_",
    "data-name": "freemelt-logo (3)",
    transform: "translate(712.834 843.747)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M29.872,3.627A16.8,16.8,0,0,0,22.787,15.4a18.575,18.575,0,0,0-7.523-1.436,18.249,18.249,0,0,0-7.129,1.766A12.978,12.978,0,0,1,19.935.011a12.625,12.625,0,0,1,9.936,3.617",
    transform: "translate(4.143 0)",
    fill: "#a0cb86",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M42.378,5.544a17.511,17.511,0,0,0-7.914,12.6c-3.274-1.423-9.107-1.5-12.33-.018-.845-.722-1.6-1.533-2.515-2.181C20.114,8.226,25.025,3.2,32.387,2.392a13.289,13.289,0,0,1,9.991,3.152",
    transform: "translate(10.347 1.232)",
    fill: "#32bfd8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M39.811,32.47c-.6-6.9-4-11.028-8.484-14.083a14.185,14.185,0,0,1,4.284-9.571,14.631,14.631,0,0,1,9.724-4.279,14.3,14.3,0,0,1,11.684,5.02A14.747,14.747,0,0,1,60.3,22.268a14.3,14.3,0,0,1-7.073,9.606A15.416,15.416,0,0,1,46.82,33.8a15.042,15.042,0,0,1-7.009-1.33",
    transform: "translate(16.52 2.395)",
    fill: "#71bc88",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M27.353,14.84c-4.321,2.842-7.615,6.721-8.484,13.057-4.3-1.836-11.031-1.193-14.451.848a14.078,14.078,0,0,1,2.39-12.162A14,14,0,0,1,27.353,14.84",
    transform: "translate(2.076 5.889)",
    fill: "#04a156",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M24.15,41.906c-.579-6.915-4-11.031-8.484-14.083A14.758,14.758,0,0,1,19.951,18.2a15.014,15.014,0,0,1,9.774-4.227,14.66,14.66,0,0,1,7.842,27.39c-3.366,1.906-9.393,2.737-13.418.544",
    transform: "translate(8.263 7.371)",
    fill: "#c5d05f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M14.122,23.447A14.572,14.572,0,0,1,24.78,27.48a14.124,14.124,0,0,1,4.534,10.036,13.989,13.989,0,0,1-3.982,10.6A14.471,14.471,0,0,1,15.3,52.656,14.439,14.439,0,0,1,4.589,48.674,14.1,14.1,0,0,1,0,38.687a14.561,14.561,0,0,1,14.119-15.24",
    transform: "translate(0 12.364)",
    fill: "#04aa7d",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreemeltPixelmelt);
export default __webpack_public_path__ + "static/media/freemelt-pixelmelt.51516127df05993a129329b347f3914b.svg";
export { ForwardRef as ReactComponent };